import React from "react";
import { H2 } from "@amzn/stencil-react-components/text";
import { Col } from "@amzn/stencil-react-components/layout";
import {
  Expander as StencilExpander,
  ExpanderTitleRendererParams,
} from "@amzn/stencil-react-components/expander";
import { secondaryTextColor } from "../../config/palette";
import "./styles.scss";

interface ExpanderProps {
  title: string;
  isExpanded?: boolean;
  children?: React.ReactNode;
  titleMod?: JSX.Element;
  onToggle?: (isExpanded: boolean) => void;
  shouldExpandOnMount?: boolean;
}

export const Expander = ({
  title,
  titleMod,
  onToggle,
  isExpanded,
  shouldExpandOnMount,
  ...props
}: ExpanderProps) => {
  const renderExpanderTitle = ({
    titleText,
    toggle,
  }: ExpanderTitleRendererParams) => {
    return (
      <>
        <H2
          onClick={toggle}
          fontSize="T300"
          color="primary70"
          className="expander-title"
        >
          {titleText}
          {titleMod ? <> {titleMod}</> : null}
        </H2>
      </>
    );
  };
  return (
    <StencilExpander
      renderTitle={renderExpanderTitle}
      titleText={title}
      {...props}
      isExpanded={isExpanded}
      shouldExpandOnMount={shouldExpandOnMount}
      onToggle={onToggle}
    >
      <Col color={secondaryTextColor} gridGap="0.5rem">
        {props.children}
      </Col>
    </StencilExpander>
  );
};
